export default __webpack_public_path__ + "static/why-ml-10-2def6b32cf4b05f5f7183c40a6af60a0.png";